import * as React from "react";
import Modal from "@mui/material/Modal";
import BaseCard from "../BaseCard";
import { Box } from "@mui/material";
import "./style.css";

const defaultStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90vh",
  overflowY: "auto",
  maxWidth: "calc(100vw - 32px)",
};

export default function BaseModal({ children, open, style, close, className }) {
  const handleClose = () => close();

  return (
    <div>
      <Modal
        className={`${className} overflow-auto`}
        // On small screens neutralize any per-modal negative `-top-*` offset so
        // tall modals stay fully in view (they scroll internally via maxHeight).
        sx={{ "@media (max-width:640px)": { top: "0 !important" } }}
        // disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <BaseCard
            className="w-[calc(100vw-32px)] sm:w-auto"
            style={{
              ...defaultStyle,
              ...style,
            }}
          >
            {children}
          </BaseCard>
        </Box>
      </Modal>
    </div>
  );
}
